import {
	PAYMENT_HOST_CODES,
	PAYMENT_TYPE_CODES,
	TRANSACTION_STATUS_CODES,
} from '../constants/transactionCodes.js';

const PAYMENT_HOST_LABELS = Object.keys(PAYMENT_HOST_CODES).reduce((labels, hostName) => {
	labels[PAYMENT_HOST_CODES[hostName]] = hostName === 'UNINITIALIZED' ? hostName : `HOST_${hostName}`;
	return labels;
}, {});

const PAYMENT_TYPE_LABELS = Object.keys(PAYMENT_TYPE_CODES).reduce((labels, typeName) => {
	labels[PAYMENT_TYPE_CODES[typeName]] = typeName.replace(/^PT_/, '');
	return labels;
}, {});

export function displayHost(code) {
	return PAYMENT_HOST_LABELS[code] || `Unknown host (${code})`;
}

export function displayPaymentType(code) {
	return PAYMENT_TYPE_LABELS[code] || `Unknown payment type (${code})`;
}

export function displayStatus(code) {
	const statusName = Object.keys(TRANSACTION_STATUS_CODES)
		.find(name => TRANSACTION_STATUS_CODES[name] === code);

	return statusName || `Unknown status (${code})`;
}
